import PropTypes from 'prop-types';
import classnames from 'classnames';

// components
import { shippingModal as messages } from '../shippingMessages';
import { Link } from 'dibs-elements/exports/Link';

// styles
import styles from './ShippingDetailsText.scss';

export function ShippingDetailsRequestQuote(props) {
    const {
        openQuoteRequestModal,
        quoteRequestStatus,
        blockRequest,
        isShippingOptionsDisclaimer = false,
    } = props;

    const requestQuoteCta = (
        <Link
            buyerLinkType="sassyBuyerStandardLink"
            onClick={openQuoteRequestModal}
            dataTn="shipping-request-open-quote-modal"
            className={styles.ctaText}
        >
            {messages.requestShippingQuoteLink}
        </Link>
    );

    return (
        <div
            className={classnames(styles.detailsCaptions, {
                [styles.shippingTableDisclaimer]: isShippingOptionsDisclaimer,
            })}
        >
            {quoteRequestStatus !== 'customQuoteProvided' && !blockRequest && (
                <p className={styles.detailsCaption}>
                    <span className={styles.requestText}>
                        {isShippingOptionsDisclaimer
                            ? messages.shippingQuoteNotDetermined(requestQuoteCta)
                            : messages.requestShippingQuote(requestQuoteCta)}
                    </span>
                </p>
            )}
            {quoteRequestStatus !== 'customQuoteProvided' && blockRequest && (
                <p className={styles.detailsCaption}>{messages.blockRequest}</p>
            )}
        </div>
    );
}

ShippingDetailsRequestQuote.propTypes = {
    openQuoteRequestModal: PropTypes.func.isRequired,
    quoteRequestStatus: PropTypes.string.isRequired,
    blockRequest: PropTypes.bool,
    isShippingOptionsDisclaimer: PropTypes.bool,
};
